export default {
	terms: "利用規約",
	and: "そして",
	actions: {
		Submit: "送信",
		BackToLogin: "ログイン画面に戻る",
		Register: "サインアップ",
		Logout: "ログアウト",
		Update: "更新",
		Verify: "確認する",
		connect: "接続",
		Taptochange: "タップして変更"
	},
	rules: {
		isRequired: "必須",
		require: "{0}は必須です",
		valid: "{0}は有効な{0}ではありません",
		cannotContainBlankStrings: "{0}には空の文字列を含めることはできません"
	},
	options: {
		gender: ["男性", "女性"]
	}
};
